import StarRankMobileBroadDetailMenu from '@/components/starrank/menu/StarRankMobileBroadcastDetailMenu';
import StarRankMobileContextMenu from '@/components/starrank/menu/StarRankMobileContextMenu';
import {goToLiveViaAppScheme} from '@/components/starrank/mobile/StarRankMobileLayout';
import {SoopUiImg} from '@/components/ui';
import {DISPLAY_THUMBNAIL} from '@/constants/common/thumbnail';
import {getCategoryThumbUrl} from '@/utils/main';
import classNames from 'classnames';
import {useState, useEffect, useMemo} from 'react';
import useGlobalUIStore from '@/stores';
import {StarrankT} from '@/utils/i18n/starrank';

/**
 * 별별랭킹 모바일 페이지, 방송 아이템 컴포넌트
 */
const StarRankMobileBroadcastItem = ({broadItem, itemIndex}) => {
  const {isDarkMode} = useGlobalUIStore();

  const [openIct, setOpenIct] = useState(false);
  const [thumbClass, setThumbClass] = useState('');
  const isAdult = useMemo(
    () => Number(broadItem?.broadGrade) === 19,
    [broadItem],
  );
  const isLock = useMemo(() => broadItem?.isPassword === 'Y', [broadItem]);
  const [isError, setIsError] = useState(false);

  /** 연령제한 / 비번방 설정 시 썸네일 결정 */
  const thumbnailImgUrl = useMemo(() => {
    if (isAdult || isLock) {
      return getCategoryThumbUrl(
        broadItem?.broadCateNo,
        DISPLAY_THUMBNAIL.HORIZONTAL,
        'live',
        isDarkMode,
      );
    }
    return broadItem?.snUrl;
  }, [broadItem?.broadCateNo, broadItem?.snUrl, isAdult, isLock, isDarkMode]);

  const onDetailClick = () => {
    setOpenIct(true);
  };

  /**
   * 방송 아이템 클릭 시 이벤트, 현재 라이브 중인 방송으로 이동
   * @param {*} streamerId
   * @param {*} broadcastId
   */
  const onClickLiveBroad = (streamerId, broadcastId) => {
    goToLiveViaAppScheme(streamerId, broadcastId);
  };

  const handleLiveImageError = () => {
    setIsError(true);
  };

  useEffect(() => {
    setIsError(false);
  }, [broadItem?.snUrl]);

  useEffect(() => {
    setThumbClass(
      classNames({
        'thumb-default': isError,
        thumb_box: !isError, // 정상 섬네일
      }),
    );
  }, [isError, broadItem?.broadGrade]);

  return (
    <li>
      <a
        onClick={() => onClickLiveBroad(broadItem?.userId, broadItem?.broadNo)}
        className={thumbClass}>
        <SoopUiImg
          src={thumbnailImgUrl}
          onError={handleLiveImageError}
          alt='broadcast-thumbnail'
        />
      </a>
      {isAdult && isLock && (
        <span class='status adult_lock'>{StarrankT('연령/비번')}</span>
      )}
      {isAdult && !isLock && (
        <span class='status adult'>{StarrankT('연령제한')}</span>
      )}
      {!isAdult && isLock && (
        <span class='status lock'>{StarrankT('비밀번호')}</span>
      )}
      <em className='rank'>{itemIndex}</em>
      {(Number(broadItem.subscriptionOnly) === 1 ||
        Number(broadItem.subscriptionOnly) === 2) && (
        <em class='_subscribe plus'>
          <span>{StarrankT('구독')}</span>
        </em>
      )}
      <div className='info_box'>
        <h3>
          <a
            onClick={() =>
              onClickLiveBroad(broadItem?.userId, broadItem?.broadNo)
            }
            className='title'>
            {!!broadItem?.isDrops && (
              <em class='ic_itemdrop'>
                <i>{StarrankT('드롭스 이벤트 진행 중')}</i>
              </em>
            )}
            {broadItem?.title}
          </a>
        </h3>
        <StarRankMobileBroadDetailMenu rankItem={broadItem} />
        <button type='button' className='btn_more' onClick={onDetailClick}>
          {StarrankT('상세정보')}
        </button>
        {openIct ? (
          <StarRankMobileContextMenu
            streamerId={broadItem?.userId}
            openIct={openIct}
            setOpenIct={setOpenIct}
          />
        ) : (
          <></>
        )}
      </div>
    </li>
  );
};

export default StarRankMobileBroadcastItem;
